import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Auth0Provider } from '@auth0/auth0-react';
import { ThemeProvider } from '@mui/material';
import { GlobalStyle, muiTheme } from './theme/index.ts';
import { getScale } from './utils/index.ts';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/shared';
import { ConfiguredApolloProvider } from './shared/ConfiguredApolloProvider.tsx';
import { AuthGuard } from './components/AuthGuard.tsx';
import { useNavbarHeight } from './hooks/useNavbarHeight.ts';
import { GeneralErrorBoundary } from './components/shared/GeneralErrorBoundary.tsx';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { PendoManager } from './utils/pendo.ts';
import './utils/sentry.ts';

const App = () => {
  const navbarHeight = useNavbarHeight();
  return (
    <ThemeProvider theme={muiTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ErrorBoundary fallback={<GeneralErrorBoundary />}>
          <ConfiguredApolloProvider>
            <Auth0Provider
              domain={import.meta.env.VITE_APP_AUTH0_DOMAIN}
              clientId={import.meta.env.VITE_APP_AUTH0_CLIENT_ID}
              authorizationParams={{
                redirect_uri: `${window.location.origin}/api/auth/callback`,
              }}
              useRefreshTokens={true}
              cacheLocation="localstorage"
            >
              <PendoManager />
              <GlobalStyle scale={getScale()} navbarHeight={navbarHeight} />
              <AuthGuard>
                <RouterProvider router={router} />
              </AuthGuard>
            </Auth0Provider>
          </ConfiguredApolloProvider>
        </ErrorBoundary>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
